import useSWRMutation, {
  SWRMutationConfiguration,
  SWRMutationResponse,
} from "swr/mutation";
import { AxiosError, AxiosResponse } from "axios";
import { createFetcher, TApiType } from "../../utils/fetcher";

export interface MutationConfig<
  Data = unknown,
  Error = unknown,
  Args = Record<string, unknown>,
> extends SWRMutationConfiguration<
    AxiosResponse<Data>["data"],
    AxiosError<Error>,
    string,
    Args
  > {}

export interface MutationReturn<Data, Error, Args = Record<string, unknown>>
  extends SWRMutationResponse<
    AxiosResponse<Data>["data"],
    AxiosError<Error>,
    string,
    Args
  > {}

export function usePostRequest<
  Response = unknown,
  Args = Record<string, unknown>,
  Error = unknown,
>(
  endpoint: string,
  config: MutationConfig<Response, Error, Args> = {},
  authed?: boolean,
  api?: TApiType,
  shouldCamelizeKeys?: boolean
): MutationReturn<Response, Error, Args> {
  const fetcher = async (url: string, { arg }: { arg: Args }) =>
    createFetcher({ authed, api, shouldCamelizeKeys })
      .request<Response>({
        method: "POST",
        url,
        data: arg,
      })
      .then(({ data }) => data);

  return useSWRMutation(endpoint, fetcher, config);
}
